import useGetArbaeenCountDataOnRegisterTime from 'src/hooks/apis/useGetArbaeenCountDataOnRegisterTime';

import {useEffect, useState} from 'react';
import arbaeenService from 'src/services/arbaeen.service';
import OverviewPilgrimCount from './OverviewPilgrimCount';
import OverviewPilgrimPercentage from './OverviewPilgrimPercentage';

const OverviewPilgrim: React.FC<{}> = () => {
  const [samah, setSamah ] = useState({entering: 0, exiting: 0 })
  const {data: pilgrims, loading: dataLoading} = useGetArbaeenCountDataOnRegisterTime({
    countIranian: true,
    countMaleIranian: true,
    countFemaleIranian: true,
    countNonIranian: true,
    countMaleNonIranian: true,
    countFemaleNonIranian: true,
    countTotal: true,
  });

  const fetchPercentageSamah = async () => {
    try {
      const {data: dataExiting} = await arbaeenService.getPercentSamahExiting();
      console.log("sdffsdf", dataExiting);
      const {data: dataEntering} = await arbaeenService.getPercentSamahEntering();
      console.log("sdffsdf", dataEntering);
      setSamah({
        entering: Number(dataEntering.value || 0), exiting: Number( dataExiting.value|| 0)
      })
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPercentageSamah();
  }, []);

  return (
    <>
      <OverviewPilgrimCount pilgrims={pilgrims} loading={dataLoading} />
      <OverviewPilgrimPercentage pilgrims={{...pilgrims, samah}} loading={dataLoading} />
    </>
  );
};
export default OverviewPilgrim;
